import { render, staticRenderFns } from "./PrintArticle.vue?vue&type=template&id=697c65a4"
import script from "./PrintArticle.vue?vue&type=script&lang=js"
export * from "./PrintArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports